import React, { useContext, useEffect, useMemo, useState } from "react";

import { GradeOpcoes, InputDropDowList2, InputFile, InputText } from "../../../../components";
import { Grid, Button } from "@material-ui/core";

import Table from "../../../../components/grade/Table";
import ChartAccountsUtils, { LedgerAccountsType, LedgerAccountsTypeDefault } from "../utils";
import ApiChartAccounts from "../../../../api/accounting/chartAccounts";
import { LedgerAccountsValidate } from "../validates";
import { AppContext } from "../../../../App";
import TablePagination from "../../../../components/grade/TablePagination";

const initialValues = {
    ledger_account_code: "",
    name: "",
    account_type: LedgerAccountsTypeDefault,
    reference: "",
};

export default function LedgerAccountsChange({ ledgerAccounts, setLedgerAccounts, id, name }) {
    const { showMessageInfo, showMessageError, setLoading } = useContext(AppContext);

    const [ledgerAccount, setLedgerAccount] = useState(initialValues);

    const [ledgerAccountsView, setLedgerAccountsView] = useState([]);
    const [ledgerAccountsViewPage, setLedgerAccountsViewPage] = useState(0);
    const [ledgerAccountsViewPerPage, setLedgerAccountsViewPerPage] = useState(10);

    const metaData = useMemo(() => [
        {
            label: "Opções",
            render: (record, index) => {
                const options = [
                    { tipo: "edit", label: "Edição" },
                    { tipo: "remove", label: "Exclusão" },
                ];

                return (
                    <span>
                        <GradeOpcoes record={record} indexRecord={index} onClickOpcoes={onClickOptions} opcoes={options} />
                    </span>
                );
            },
        },
        {
            label: "Tipo",
            render: (record) => {
                return <>{ChartAccountsUtils().LedgerAccountsTypeText(record.account_type)}</>;
            },
        },
        { label: "Conta", field: "ledger_account_code" },
        { label: "Nome", field: "name" },
        { label: "Referência", field: "reference" },
        { label: "Dh.Criação", field: "created_at", format: "datetime", minWidth: 160 },
        { label: "Dh.Atualização", field: "updated_at", format: "datetime", minWidth: 160 },
    ]);

    const onClickOptions = async (record, type, index) => {
        switch (type) {
            case "edit":
                setLedgerAccount({ ...record });
                break;
            case "remove":
                const ledgerAccountsCustom = [...ledgerAccounts];
                ledgerAccountsCustom.splice(index, 1);

                setLedgerAccounts(ledgerAccountsCustom);
                break;
            default:
                break;
        }
    };

    const refreshLedgerAccountsView = (page, perPage, ledgerAccounts) => {
        setLedgerAccountsViewPerPage(perPage);
        setLedgerAccountsViewPage(page);

        const initial = page === 0 ? 0 : perPage * page;
        const length = page === 0 ? perPage : perPage * (page + 1);

        setLedgerAccountsView(ledgerAccounts.slice(initial, length));
    };

    const exportLedgerAccounts = async () => {
        setLoading(true);
        try {
            const response = await ApiChartAccounts().exportLedgerAccounts(id, `Contas-Contabeis-${name || "Modelo"}`);

            if (!response.status) {
                showMessageError(response.message);
                return;
            }
        } finally {
            setLoading(false);
        }
    };

    const importLedgerAccounts = async (e) => {
        setLoading(true);

        try {
            const file = e.target.files[Object.keys(e.target.files)[0]];

            const response = await ApiChartAccounts().importLedgerAccounts(file);

            if (!response.status) {
                showMessageError(response.message);
                return;
            }

            const ledgerAccountsImport = response.data;
            const ledgerAccountsCustom = [...ledgerAccounts];
            let created = 0,
                updated = 0;

            for (const ledgerAccountImport of ledgerAccountsImport) {
                const ledgerAccountIndex = ledgerAccountsCustom.findIndex((rec) => rec.ledger_account_code === ledgerAccountImport.ledger_account_code);

                if (ledgerAccountIndex === -1) {
                    ledgerAccountsCustom.push(ledgerAccountImport);
                    created++;
                } else {
                    ledgerAccountsCustom[ledgerAccountIndex].name = ledgerAccountImport.name;
                    ledgerAccountsCustom[ledgerAccountIndex].account_type = ledgerAccountImport.account_type || null;
                    ledgerAccountsCustom[ledgerAccountIndex].reference = ledgerAccountImport.reference || null;
                    updated++;
                }
            }

            if (created || updated) {
                setLedgerAccounts(ledgerAccountsCustom);
                refreshLedgerAccountsView(0, ledgerAccountsViewPerPage, ledgerAccountsCustom);
            }

            showMessageInfo(["Contas importadas com sucesso", `Novas: ${created}`, `Atualizadas: ${updated}`]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refreshLedgerAccountsView(ledgerAccountsViewPage, ledgerAccountsViewPerPage, ledgerAccounts);
    }, [ledgerAccounts]);

    return (
        <>
            <Grid container spacing={1} style={{ paddingTop: "8px" }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={2}>
                        <InputDropDowList2
                            value={ledgerAccount.account_type}
                            onChangeValue={(e) => setLedgerAccount({ ...ledgerAccount, account_type: e.target.value })}
                            data={LedgerAccountsType}
                            label={"Tipo"}
                        ></InputDropDowList2>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <InputText
                            required
                            label="Conta"
                            value={ledgerAccount.ledger_account_code}
                            onChangeValue={(e) => setLedgerAccount({ ...ledgerAccount, ledger_account_code: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            label="Nome"
                            value={ledgerAccount.name}
                            onChangeValue={(e) => setLedgerAccount({ ...ledgerAccount, name: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <InputText
                            label="Referência"
                            value={ledgerAccount.reference}
                            onChangeValue={(e) => setLedgerAccount({ ...ledgerAccount, reference: e.target.value })}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1} style={{ paddingTop: "8px", paddingBottom: "8px" }}>
                    <Grid item xs={12} sm={8}>
                        <Button
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px" }}
                            size="small"
                            variant="contained"
                            color="secondary"
                            onClick={() => setLedgerAccount(initialValues)}
                        >
                            Nova conta
                        </Button>
                        <Button
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                                const ledgerAccountIndex = ledgerAccounts.findIndex((rec) => rec.ledger_account_code === ledgerAccount.ledger_account_code);
                                const ledgerAccountsCustom = [...ledgerAccounts];

                                // Validate
                                const validate = await ApiChartAccounts().apiDefault.validate(LedgerAccountsValidate(), ledgerAccount);
                                if (!validate.status) {
                                    showMessageError(validate.message);
                                    return;
                                }

                                if (ledgerAccountIndex === -1) {
                                    ledgerAccountsCustom.push(ledgerAccount);
                                } else {
                                    ledgerAccountsCustom[ledgerAccountIndex] = ledgerAccount;
                                }

                                setLedgerAccounts(ledgerAccountsCustom);
                                setLedgerAccount(initialValues);
                            }}
                        >
                            Salvar
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                            color="default"
                            onClick={() => exportLedgerAccounts()}
                        >
                            Exportar contas
                        </Button>
                        <InputFile
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                            color="default"
                            onFileSelect={(e) => importLedgerAccounts(e)}
                            fileExtension={".xlsx"}
                            label={"Importar contas"}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Table dataSource={ledgerAccountsView} metaData={metaData} />
                <TablePagination
                    rowCount={ledgerAccounts.length || 0}
                    rowPage={ledgerAccountsViewPerPage}
                    page={ledgerAccountsViewPage}
                    onPageChange={(event, newPage) => {
                        refreshLedgerAccountsView(newPage, ledgerAccountsViewPerPage, ledgerAccounts);
                    }}
                    onRowsPerPageChange={(event) => {
                        refreshLedgerAccountsView(0, event.target.value, ledgerAccounts);
                    }}
                />
            </Grid>
        </>
    );
}
